/**
 * Etichetta breve dell'esito di una task commerciale, da mostrare sull'evento nel calendario:
 * la parte prima di ":" (l'esito rapido salva "Assente: nota"), accorciata. null = niente da mostrare.
 */
export function outcomeShortLabel(outcome: string | null | undefined, max = 24): string | null {
  const head = String(outcome ?? '').split(':')[0].replace(/\s+/g, ' ').trim();
  if (!head) return null;
  return head.length > max ? `${head.slice(0, max - 1).trimEnd()}…` : head;
}

/** Esito da mostrare sull'evento: solo per le task chiuse che hanno un esito scritto. */
export function eventOutcomeLabel(md: { outcome?: string | null; done?: boolean; is_completed?: boolean } | null | undefined): string | null {
  if (!md || !(md.done || md.is_completed)) return null;
  return outcomeShortLabel(md.outcome);
}

/** Testo sicuro da inserire nell'HTML dell'evento (FullCalendar eventContent). */
export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string));
}

const HEX = /^#[0-9a-fA-F]{6}$/;

/**
 * Colore dell'etichetta dell'esito: quello dell'esito rapido con la stessa etichetta (Impostazioni ›
 * Calendario › Esiti), altrimenti verde se la task e' chiusa, grigio se e' ancora aperta.
 */
export function outcomeColor(
  outcome: string | null | undefined,
  outcomes: ReadonlyArray<{ label: string; color?: string }> | null | undefined,
  closed: boolean,
): string {
  const head = outcomeShortLabel(outcome, 200)?.toLowerCase();
  const hit = head ? (outcomes || []).find(o => o.label.trim().toLowerCase() === head) : undefined;
  if (hit?.color && HEX.test(hit.color)) return hit.color;
  return closed ? '#0F7B6C' : '#787774';
}
